import { isDashboardAreaPath } from './dashboardAreaRoutes';

/** Indica se o item de menu deve aparecer ativo, preferindo o irmão mais específico. */
export function isSidebarPathActive(
  pathname: string,
  itemPath: string,
  siblingPaths: readonly string[] = [],
): boolean {
  const current = normalizePath(pathname);
  const target = normalizePath(itemPath);

  // Visões gerais de departamento (`/people`, …) só na rota exata —
  // evita marcar/expandir Pessoas em rotas de Conta como `/people/my-team`.
  if (isDashboardAreaPath(target)) {
    return current === target;
  }

  if (!pathMatches(current, target)) {
    return false;
  }

  const hasMoreSpecificSibling = siblingPaths.some((siblingPath) => {
    const sibling = normalizePath(siblingPath);
    if (sibling === target) {
      return false;
    }

    if (!pathMatches(current, sibling)) {
      return false;
    }

    return sibling.startsWith(`${target}/`);
  });

  return !hasMoreSpecificSibling;
}

function normalizePath(path: string): string {
  const withoutQuery = (path || '/').split('?')[0] || '/';
  if (withoutQuery === '/') {
    return '/';
  }

  return withoutQuery.endsWith('/') ? withoutQuery.slice(0, -1) : withoutQuery;
}

function pathMatches(pathname: string, itemPath: string): boolean {
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}
